import createReactComponent from '../createReactComponent';
export default createReactComponent('outline', 'backslash', 'IconBackslash', [["path",{"d":"M7 5l10 14","key":"svg-0"}]]);